// 智慧凭证
import Log from '../view/log'
import InvoiceNav from '../view/Invoice/InvoiceNav'
import InvoiceOverView from '../view/Invoice/InvoiceOverView/InvoiceOverView'
import InvoiceSellerManage from '../view/Invoice/InvoiceSeller/InvoiceSellerManage'
import InvoiceSellerAdd from '../view/Invoice/InvoiceSeller/InvoiceSellerAdd'
import InvoiceSellerModify from '../view/Invoice/InvoiceSeller/InvoiceSellerModify'
import InvoiceManage from '../view/Invoice/InvoiceManage/InvoiceManage'
import InvoiceInfoCurrent from '../view/Invoice/InvoiceManage/InvoiceInfoCurrent'
import InvoiceCollectionRecord from '../view/Invoice/InvoiceManage/InvoiceCollectionRecord'
import InvoiceTaxRateManage from '../view/Invoice/InvoiceTaxRate/InvoiceTaxRateManage'
import InvoiceTaxRateAdd from '../view/Invoice/InvoiceTaxRate/InvoiceTaxRateAdd'
import InvoiceTaxRateModify from '../view/Invoice/InvoiceTaxRate/InvoiceTaxRateModify'
import InvoiceRiseManage from '../view/Invoice/InvoiceRise/InvoiceRiseManage'
import InvoiceRiseAdd from '../view/Invoice/InvoiceRise/InvoiceRiseAdd'
import InvoiceRiseModify from '../view/Invoice/InvoiceRise/InvoiceRiseModify'
import InvoiceConfig from '../view/Invoice/InvoiceConfig/InvoiceConfig'
import InvoiceReceiptManage from '../view/Invoice/InvoiceReceiptManage/InvoiceReceiptManage'
import InvoiceReceiptCollectionRecord from '../view/Invoice/InvoiceReceiptManage/InvoiceReceiptCollectionRecord'
import invoiceRemarksManage from '../view/Invoice/invoiceremarks/invoiceRemarksManage'

export default [
    /* 智慧凭证 */
  {
    path: '/invoice_over_view',
    name: 'invoice-over-view',
    components: {
      default: InvoiceNav,
      a: InvoiceOverView
    }
  },
  {
    path: '/invoice_seller_manage',
    name: 'invoice-seller-manage',
    components: {
      default: InvoiceNav,
      a: InvoiceSellerManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/invoice_seller_add',
    name: 'invoice-seller-add',
    components: {
      default: InvoiceNav,
      a: InvoiceSellerAdd
    }
  },
  {
    path: '/invoice_seller_modify/:id',
    name: 'invoice-seller-modify',
    components: {
      default: InvoiceNav,
      a: InvoiceSellerModify
    }
  },
  {
    path: '/invoice_manage',
    name: 'invoice-manage',
    components: {
      default: InvoiceNav,
      a: InvoiceManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/invoice_info_current/:id',
    name: 'invoice-info-current',
    components: {
      default: InvoiceNav,
      a: InvoiceInfoCurrent
    }
  },
  {
    path: '/invoice_collection_record',
    name: 'invoice-collection-record',
    components: {
      default: InvoiceNav,
      a: InvoiceCollectionRecord
    }
  },
  {
    path: '/invoice_tax_rate_manage',
    name: 'invoice-tax-rate-manage',
    components: {
      default: InvoiceNav,
      a: InvoiceTaxRateManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/invoice_tax_rate_add',
    name: 'invoice-tax-rate-add',
    components: {
      default: InvoiceNav,
      a: InvoiceTaxRateAdd
    }
  },
  {
    path: '/invoice_tax_rate_modify/:id',
    name: 'invoice-tax-rate-modify',
    components: {
      default: InvoiceNav,
      a: InvoiceTaxRateModify
    }
  },
  {
    path: '/invoice_rise_manage',
    name: 'invoice-rise-manage',
    components: {
      default: InvoiceNav,
      a: InvoiceRiseManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/invoice_rise_add',
    name: 'invoice-rise-add',
    components: {
      default: InvoiceNav,
      a: InvoiceRiseAdd
    }
  },
  {
    path: '/invoice_rise_modify/:id',
    name: 'invoice-rise-modify',
    components: {
      default: InvoiceNav,
      a: InvoiceRiseModify
    }
  },
  {
    path: '/invoice_config',
    name: 'invoice-config',
    components: {
      default: InvoiceNav,
      a: InvoiceConfig
    }
  },
  {
    path: '/invoice_receipt_manage',
    name: 'invoice-receipt-manage',
    components: {
      default: InvoiceNav,
      a: InvoiceReceiptManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/invoice_receipt_collection_record',
    name: 'invoice-receipt-collection-record',
    components: {
      default: InvoiceNav,
      a: InvoiceReceiptCollectionRecord
    }
  },
  // 备注管理
  {
    path: '/invoice_remarks_manage',
    name: 'invoice-remarks-manage',
    components: {
      default: InvoiceNav,
      a: invoiceRemarksManage
    },
  },
  /* 智慧凭证 */
  // 智慧凭证操作日志
  {
    path: '/invoice_log',
    name: 'invoice-log',
    components: {
      default: InvoiceNav,
      a: Log
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/Invoice.js